import type { FC, ReactNode } from "react"
import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react"

type VotingModalContainerProps = {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
}

const VotingModalContainer: FC<VotingModalContainerProps> = ({
  children,
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        data-qa="proposal-details-vote-onchain-modal"
        minW={{ base: "auto", lg: "30rem" }}
        my={{ base: "auto", lg: "1rem" }}
        rounded="1rem"
      >
        <ModalHeader borderBottom="gray.light">
          <Flex justify="center">
            <Text as="h5" textStyle="h5">
              Voting
            </Text>
          </Flex>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody maxHeight="100vh" overflowY="auto" p={0}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default VotingModalContainer
